import http from '@utils/http'
// 页面整体布局
export const  queryLayout = (data): Promise<any> => http.post('/storefront/queryLayout', data)
// 图文信息
export const  queryImageTextInfo = (data): Promise<any> => http.post('/storefront/queryImageTextInfo', data)
// 货架信息
export const  queryGoodsShelfInfo = (data): Promise<any> => http.post('/storefront/queryGoodsShelfInfo', data)
// 导购信息
export const  queryShoppingGuildInfo = (data): Promise<any> => http.post('/storefront/queryShoppingGuildInfo', data)
// 自定义信息
export const  queryCustomInfo = (data): Promise<any> => http.post('/storefront/queryCustomInfo', data)

// 查询套餐信息
export const  queryUnityPlanDetail = (data): Promise<any> => http.post('/storefront/queryPlanDetail', data)